import { get } from "lodash";
import { HeatmapTarget } from "types/Charts";

function calculateIntensityAtPosition(
    maxWidth: number,
    sigma: number,
    centerX: number,
    centerY: number,
    posX: number,
    posY: number,
    maxIntensity: number
) {
    // Calculate the radius of the dot
    const radius = maxWidth / 2;

    // Calculate the distance of the position from the center
    const dx = posX - centerX;
    const dy = posY - centerY;
    const distance = Math.sqrt(dx * dx + dy * dy);

    // If the point is outside the radius, the intensity is 0
    if (distance > radius) {
        return 0;
    }

    // Apply Gaussian decay to calculate intensity
    const intensity =
        maxIntensity *
        Math.exp(-Math.pow(distance, 2) / (2 * Math.pow(sigma, 2)));

    // Return the calculated intensity, ensuring it’s an integer
    return Math.floor(intensity);
}

const transformTargetData = (deviceId: string, targetData: any[]) => {
    /**
     * Intensity range for the heatmap
     * The values for the UI are between 0 and 100
     */
    const intensityRange = [0, 2];

    const targetHeight = Number(targetData[3]);
    const intensity =
        (100 / (intensityRange[1] - intensityRange[0])) * targetHeight +
        intensityRange[0];

    const target: HeatmapTarget = {
        deviceId,
        targetId: String(targetData[0]),
        x: Number(targetData[1]),
        y: Number(targetData[2]),
        z: targetHeight,
        intensity,
    };

    return target;
};

const transformSensorMessage = (messages: any[3][]) => {
    let deviceData: Record<string, HeatmapTarget[]> = {};
    const timestamp = Number(get(messages, "[0][1]", 0)) * 1000;

    for (const message of messages) {
        const deviceId = message[0];
        const sensorData = message[2];

        const formatedData: HeatmapTarget[] = sensorData.map(
            (targetData: any[]) => {
                const formatedSensorData = transformTargetData(
                    deviceId,
                    targetData
                );
                return formatedSensorData;
            }
        );

        deviceData[deviceId] = formatedData;
    }

    return {
        range: {
            minX: -3,
            maxX: 3,
            minY: -3,
            maxY: 3,
        },
        timestamp,
        targets: deviceData,
    };
};

export { calculateIntensityAtPosition, transformSensorMessage };
